import Loader from "../Ui/Loader";
import { PublicSignupBackLink, PublicSignupOrgPanel } from "../PublicSignup/PublicSignupShell";
import { usePublicInvestorCompany } from "../../hooks/usePublicInvestorCompany";

const backgroundImageStyleRight = {
  backgroundImage: `url("../Images/Login/sign-up-right.png")`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

export function PublicInvestorAuthLayout({
  title,
  subtitle,
  backTo,
  backLabel = "Back",
  topLinks,
  children,
}) {
  const { companyDetails, isLoadingCoop, isCoopError } = usePublicInvestorCompany();

  if (isLoadingCoop) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-[#fafafa]">
        <Loader />
      </div>
    );
  }

  if (isCoopError || !companyDetails) {
    return (
      <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center px-4 text-center bg-[#fafafa]">
        <h2 className="text-[#383838] fw-bold mb-2">Organisation not found</h2>
        <p className="text-[#525252] mb-4 max-w-md">
          We could not load this organisation&apos;s investor portal.
        </p>
        {backTo ? (
          <PublicSignupBackLink to={backTo} label={backLabel} />
        ) : null}
      </div>
    );
  }

  return (
    <div className="Login min-h-screen bg-[#fafafa] overflow-x-hidden">
      <div
        className="hidden lg:flex fixed inset-y-0 right-0 z-0 w-[42%] items-center justify-center p-8"
        style={backgroundImageStyleRight}
      >
        <PublicSignupOrgPanel
          companyDetails={companyDetails}
          branches={[]}
          isLoadingBranches={false}
          compact
          showBranches={false}
        />
      </div>

      <div className="relative z-10 w-full lg:w-[58%] bg-primary-soft min-w-0 min-h-screen">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-4 lg:py-6 pb-8">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
            {backTo ? (
              <PublicSignupBackLink to={backTo} label={backLabel} />
            ) : (
              <span />
            )}
            {topLinks ? <div className="text-xs text-[#525252]">{topLinks}</div> : null}
          </div>

          <div className="lg:hidden mb-4">
            <PublicSignupOrgPanel
              companyDetails={companyDetails}
              branches={[]}
              isLoadingBranches={false}
              compact
              showBranches={false}
            />
          </div>

          <div className="bg-white rounded-xl border border-[#e0e0e0]/80 shadow-sm px-4 sm:px-5 py-4 sm:py-5">
            <h1 className="text-[#383838] fw-bold text-xl sm:text-2xl mb-1">{title}</h1>
            {subtitle ? <p className="text-[#525252] text-sm mb-0">{subtitle}</p> : null}
            <div className="mt-4">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
